// extracted by mini-css-extract-plugin
module.exports =  {"container":"mXoNk0qudAXTa7Z1pgqW","buttons":"GXVKF25f0VF7j55kMMdv","heading":"k1bzqqkIrAMw5CyydkZw"};